import { observer } from "mobx-react-lite";
import { Layer, Source } from "react-map-gl";
import { useMapStore } from "../..";
import { ILayerWithAbilityToOverrideIsStyleLoadedProps } from "../../interfaces/IlayerProps";

function SatelliteNAIPBaseMapLayer({ visible, isStyleLoadedOverride }: ILayerWithAbilityToOverrideIsStyleLoadedProps) {
    const mapStore = useMapStore();
    if (!(isStyleLoadedOverride ?? mapStore.isStyleLoaded))
        return null;

    return (
        <Source id="satelliteNAIPBaseMapSource" type="raster" url="mapbox://mapbox.naip" tileSize={256}>
            <Layer
                id="satelliteNAIPBaseMapLayer"
                type="raster"
                slot="top"
                beforeId="mapbox-satellite"
                layout={{
                    "visibility": visible ? "visible" : "none",
                }}
            />
        </Source>
    );
}

export default observer(SatelliteNAIPBaseMapLayer);